import React from 'react';
import { goldButton } from '../PageShell';

export const RoutePreviewModal = ({ preview, busy, onConfirm, onCancel }) => (
  <div
    className="fixed inset-0 z-[120] flex items-center justify-center p-4"
    style={{ background: 'rgba(10,10,10,0.9)' }}
    data-testid="route-preview-modal"
    onClick={() => !busy && onCancel()}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{ background: '#141414', border: '1px solid #C9A84C', width: '100%', maxWidth: '480px', maxHeight: '85vh', overflowY: 'auto', padding: '24px' }}
    >
      <span className="font-body uppercase" style={{ fontSize: '10px', letterSpacing: '2px', color: '#C9A84C' }}>Vista previa</span>
      <h3 className="font-display" style={{ fontSize: '22px', fontWeight: 700, color: '#F5F5F0', marginTop: '4px' }}>
        Ruta antes de enviar al chofer
      </h3>
      <p className="font-body mt-2" style={{ fontSize: '13px', color: '#C2C1B6' }} data-testid="route-preview-origin">
        Punto de partida: <strong style={{ color: '#E8C96A' }}>{preview.data.origin_name || 'Restaurante (predeterminado)'}</strong>
      </p>

      <div className="mt-4 p-3 flex items-center justify-between gap-3" style={{ background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.25)' }}>
        <div style={{ minWidth: 0 }}>
          <p className="font-body" style={{ fontSize: '11px', color: '#9A7522', textTransform: 'uppercase', letterSpacing: '1px' }}>Distancia total (ida y vuelta a la sede)</p>
          <p className="font-bebas" style={{ fontSize: '26px', color: '#C9A84C' }} data-testid="route-preview-total-km">
            {preview.data.total_km} km
          </p>
        </div>
        <div style={{ textAlign: 'right', paddingLeft: '12px' }}>
          <p className="font-body" style={{ fontSize: '11px', color: '#9A7522', textTransform: 'uppercase', letterSpacing: '1px' }}>Paradas</p>
          <p className="font-bebas" style={{ fontSize: '26px', color: '#C9A84C' }}>{preview.data.stops.length}</p>
        </div>
        <div style={{ textAlign: 'right', paddingLeft: '12px' }}>
          <p className="font-body" style={{ fontSize: '11px', color: '#9A7522', textTransform: 'uppercase', letterSpacing: '1px' }}>Pedidos</p>
          <p className="font-bebas" style={{ fontSize: '26px', color: '#C9A84C' }}>{preview.data.total_orders}</p>
        </div>
      </div>

      <p className="font-body mt-4" style={{ fontSize: '12px', color: '#9A7522', textTransform: 'uppercase', letterSpacing: '1px' }}>
        Paradas en orden (de la sede a la más lejana)
      </p>
      <ol className="mt-2 space-y-2" data-testid="route-preview-stops" style={{ listStyle: 'none' }}>
        {preview.data.stops.map((s) => (
          <li
            key={s.seq}
            className="flex items-center justify-between p-2"
            style={{ background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.12)' }}
            data-testid={`route-preview-stop-${s.seq}`}
          >
            <span className="font-body" style={{ fontSize: '13px', color: '#F5F5F0' }}>
              <strong style={{ color: '#C9A84C' }}>{s.seq}.</strong> {s.name} <span style={{ color: '#C2C1B6' }}>({s.count} pedido{s.count > 1 ? 's' : ''})</span>
            </span>
            <span className="font-body" style={{ fontSize: '12px', color: '#9A7522' }}>{s.leg_km} km</span>
          </li>
        ))}
        <li className="flex items-center justify-between p-2" style={{ background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.12)' }}>
          <span className="font-body" style={{ fontSize: '13px', color: '#F5F5F0' }}>
            <strong style={{ color: '#C9A84C' }}>↩</strong> Regreso a la sede
          </span>
          <span className="font-body" style={{ fontSize: '12px', color: '#9A7522' }}>{preview.data.return_km} km</span>
        </li>
      </ol>

      <p className="font-body mt-4" style={{ fontSize: '12px', color: '#E8C96A' }}>
        Al confirmar, estos {preview.data.total_orders} pedido(s) se marcarán como "En ruta" y se notificará por email a los clientes.
      </p>

      <div className="flex gap-3 mt-5">
        <button
          onClick={onCancel}
          disabled={busy}
          className="font-body"
          style={{ flex: 1, background: 'none', border: '1px solid rgba(201,168,76,0.4)', color: '#C9A84C', padding: '11px', cursor: busy ? 'default' : 'pointer', fontSize: '13px', opacity: busy ? 0.6 : 1 }}
          data-testid="route-preview-cancel"
        >
          Cancelar
        </button>
        <button
          onClick={onConfirm}
          disabled={busy}
          style={{ ...goldButton, flex: 1, opacity: busy ? 0.6 : 1, cursor: busy ? 'default' : 'pointer' }}
          data-testid="route-preview-confirm"
        >
          {busy ? 'Enviando…' : 'Confirmar y enviar al chofer'}
        </button>
      </div>
    </div>
  </div>
);
